/**
 * Derives a deterministic HSL color from an arbitrary string (e.g. a drill-rig name).
 * Uses DJB2 (XOR variant) for hashing, then maps through the golden ratio to spread
 * hues evenly across the spectrum and avoid perceptual clustering.
 * The input is lowercased before hashing so casing differences produce the same color.
 */
export function hslFromString(str: string): string {
  const s = str.toLowerCase();
  let hash = 5381;
  for (let i = 0; i < s.length; i++) {
    // DJB2 XOR: hash * 33 XOR charCode
    hash = (((hash << 5) + hash) ^ s.charCodeAt(i)) & 0xffffffff;
  }
  // Golden-ratio multiplication spreads sequential hashes across the full hue wheel
  const h = Math.round(((Math.abs(hash) * 0.618033988749895) % 1) * 360);
  return `hsl(${h}, 65%, 45%)`;
}

/**
 * Picks a color for item `index` out of `total` items, evenly spaced around the hue
 * wheel. Unlike hashing each label independently, this guarantees a minimum hue
 * distance between any two items in the set, so colors stay distinguishable even as
 * the number of items (e.g. drill rigs) grows.
 */
export function distinctHslColor(index: number, total: number): string {
  const h = total > 0 ? Math.round((index * 360) / total) : 0;
  return `hsl(${h}, 65%, 45%)`;
}
